import { PortfolioResponse } from '@bitte-ai/types';
import { Message, generateId } from 'ai';
import { AccountOverview } from '../..';
import { WelcomeList } from './WelcomeList';

const WELCOME_QUESTIONS = [
  'What are the trending tokens?',
  'Who are the top traders?',
  'What yield opportunities are available?',
  'How is my portfolio performing?',
];

const WELCOME_ACTIONS = [
  'Get my portfolio overview',
  'Show me my balance',
  'Swap ETH for USDC',
  'Fetch yield opportunities',
  'Check my portfolio value',
];

const WELCOME_COLORS = {
  QUESTIONS: '#60A5FA33',
  ACTIONS: '#432C27',
} as const;

interface WelcomeAccountOverviewProps {
  data: PortfolioResponse;
  evmAddress: string;
  append: (message: Message) => void;
}

const WelcomeAccountOverview: React.FC<WelcomeAccountOverviewProps> = ({
  data,
  evmAddress,
  append,
}) => {
  const handleItemClick = (content: string) => {
    append({
      id: generateId(),
      role: 'user',
      content,
    });
  };

  return (
    <div className="bitte-w-full">
      <AccountOverview data={data} walletAddress={evmAddress} />
      <div className="bitte-mt-6 bitte-px-6 bitte-grid bitte-grid-cols-1 md:bitte-grid-cols-2 bitte-gap-4">
        <WelcomeList
          items={WELCOME_QUESTIONS}
          label="Questions"
          bgColor={WELCOME_COLORS.QUESTIONS}
          onItemClick={handleItemClick}
        />
        <WelcomeList
          items={WELCOME_ACTIONS}
          label="Actions"
          bgColor={WELCOME_COLORS.ACTIONS}
          onItemClick={handleItemClick}
        />
      </div>
    </div>
  );
};

export default WelcomeAccountOverview;
